import { TabKey } from "./Tabs.model";

export type DeviceTabConfig = {
  key: TabKey;
  label: string;
  condition: boolean;
};

export const getDeviceTabConfig = (
  isClockStation: boolean | null | undefined,
  isAdmin: boolean | null | undefined
): DeviceTabConfig[] => [
  { key: "main", label: "Главная", condition: true },
  { key: "primary", label: "Первичные часы", condition: true },
  { key: "secondary", label: "Вторичные часы", condition: Boolean(isClockStation) },
  { key: "relay", label: "Настройки реле", condition: Boolean(isClockStation) },
  { key: "chimes", label: "Бой часов", condition: Boolean(isClockStation) },
  { key: "devices", label: "Устройства BIGLine", condition: true },
  // { key: "devices-test", label: "Устройства BIGLine test", condition: true },
  { key: "network", label: "Настройки сети", condition: true },
  { key: "system", label: "Настройки системы", condition: true },
  { key: "broadcast-commands", label: "Широковещательные", condition: true },
  { key: "blocks", label: "Блокировки", condition: Boolean(isAdmin) && Boolean(isClockStation) },
  { key: "logs", label: "Логи системы", condition: Boolean(isAdmin) },
  { key: "test", label: "Тестовый раздел", condition: true }
];
